export var NEWBUILDINGS_NOT_FOUND_ERROR = {
  title: 'Ничего не найдено',
  text: 'Укажите другой ЖК или смените регион поиска'
};
export var FLATS_NOT_FOUND_ERROR = {
  title: 'Ничего не найдено',
  text: 'Укажите другой адрес'
};
export var SERVER_ERROR = {
  title: 'Не удалось получить возможные варианты',
  text: 'Попробуйте еще раз'
};